/**
 * 새 소식 — 사용자가 새로 할 수 있게 된 큰 기능만 적는다.
 * 버그 수정·문구 변경·자잘한 화면 손질은 넣지 않는다.
 *
 * 새 항목은 맨 위에 넣는다. 맨 위 id 가 바뀌면 홈의 ✦ 에 점이 찍힌다.
 * go: '써보기' 가 데려갈 곳. HomeScreen 의 goNews 가 받는다. 없으면 버튼이 없다.
 *   month · quotes · wishlist · orbit  → 내 행성의 그 탭
 *   constellation · trending           → 홈에서 그 창
 *   trail                              → 우주 궤적 화면
 *   profile                            → 내 행성
 *   bookpti                            → 북BTI 창
 *   booklist                           → 앱 밖 책 목록 페이지(새 탭)
 *   hotbooks                           → 홈의 '도서관 대출 급상승 책' 을 펼침
 *   regionbooks                        → 홈의 '우리 지역 인기 책' 을 펼침
 */
export const RELEASES = [
  {
    id: "2026-10-02-quotes-export",
    date: "2026-10-02",
    icon: "⬇",
    title: "옮긴 문장을 파일로 받기",
    body: "내 행성 → 문장 탭에서 모아둔 문장을 엑셀로 받을 수 있어요. 문장과 책·저자·쪽수, 공개 여부, 남긴 날이 함께 담겨요.",
    go: "quotes",
  },
  {
    id: "2026-09-26-universe-labels",
    date: "2026-09-26",
    icon: "🔭",
    title: "우주 지도를 당기면 책 이름이 보여요",
    body: "겹치는 책이 많은 자리는 이름을 다 적을 수 없어 점으로만 있었어요. 이제 전체 화면에서 확대하면 가려졌던 책 제목이 하나씩 나타나요.",
    go: "trail",
  },
  {
    id: "2026-09-26-notif-time",
    date: "2026-09-26",
    icon: "🔔",
    title: "알림에 언제인지 표시",
    body: "알림마다 '방금', '5시간 전', '3일 전' 처럼 언제 온 것인지 보여요. 일주일이 넘으면 날짜로 바뀌어요. 최신 알림이 위로 오도록 순서도 바로잡았어요.",
  },
  {
    id: "2026-09-23-books-csv",
    date: "2026-09-23",
    icon: "⬇",
    title: "내 책을 엑셀로 내보내기",
    body: "내 행성 탭 위의 '엑셀로 내보내기' 를 누르면 지금까지 등록한 책이 파일로 받아져요. 제목·저자·상태·등록일·완독일·감정 좌표·ISBN 이 들어 있어요. 엑셀, 넘버스, 구글 시트에서 바로 열려요.",
    go: "profile",
  },
  {
    id: "2026-09-20-fox",
    date: "2026-09-20",
    icon: "🦊",
    title: "50권이 되면 여우가 찾아와요",
    body: "읽고 있거나 다 읽은 책이 50권이 되면, 여행자 옆 비탈에 여우가 와서 앉아요. 다른 사람이 내 행성을 볼 때도 보여요.",
    go: "profile",
  },
  {
    id: "2026-09-17-region-books",
    date: "2026-09-17",
    icon: "📍",
    title: "우리 지역 인기 책",
    body: "사는 시·도를 고르면 그 지역 도서관에서 요즘 많이 빌린 책과, 전국보다 우리 지역에서 유독 많이 빌린 책을 볼 수 있어요. 고른 지역은 이 기기에만 저장돼요.",
    go: "regionbooks",
  },
  {
    id: "2026-09-17-traveler",
    date: "2026-09-17",
    icon: "🧣",
    title: "30권이 쌓이면 행성에 여행자가 찾아와요",
    body: "읽고 있거나 다 읽은 책이 30권이 되면, 목도리를 두른 작은 여행자가 장미 한 송이와 함께 내 행성에 내려앉아요. 다른 사람이 내 행성을 볼 때도 보여요.",
    go: "profile",
  },
  {
    id: "2026-09-16-hot-books",
    date: "2026-09-16",
    icon: "📈",
    title: "도서관 대출 급상승 책",
    body: "전국 도서관에서 최근 2주간 대출 순위가 오른 책을 홈에서 볼 수 있어요. 책을 누르면 소개와 연령별 대출이 펼쳐지고, 마음에 드는 책은 바로 읽고 싶은 책으로 담을 수 있어요.",
    go: "hotbooks",
  },
  {
    id: "2026-09-13-booklist",
    date: "2026-09-13",
    icon: "📚",
    title: "책 목록 페이지",
    body: "MUROO에 등록된 책을 한 자리에서 볼 수 있어요. 장르별로 묶여 있고, 각 책을 몇 명이 담았는지 함께 보여요. 홈의 'N권이 MUROO에 등록되어 있어요' 를 눌러도 열립니다.",
    go: "booklist",
  },
  {
    id: "2026-09-12-universe-feed",
    date: "2026-09-12",
    icon: "✦",
    title: "우주의 이야기 · 아래 이동 막대",
    body: "'다른 행성' 탭에서 다른 행성들이 무엇을 읽고 무엇을 남겼는지 시간순으로 볼 수 있어요. 화면 아래 막대로 홈·다른 행성·내 행성·우주 궤적을 오갈 수 있어요.",
  },
  {
    id: "2026-09-12-bookpti",
    date: "2026-09-12",
    icon: "📖",
    title: "북BTI — 나는 어떤 독자인가",
    body: "질문 여덟 개로 여덟 유형 중 내 독서 성향을 찾아요. 결과에서 나와 닮은 책, 같은 유형의 행성, 가장 닮은 행성까지 이어져요.",
    go: "bookpti",
  },
  {
    id: "2026-09-11-monthly-stats",
    date: "2026-09-11",
    icon: "📊",
    title: "월별 독서 통계",
    body: "한 달 동안 읽은 책과 장르, 감정의 결을 한 장에 모았어요. 달을 골라 보고, 인스타 피드·스토리 크기로 저장할 수 있어요.",
    go: "month",
  },
  {
    id: "2026-09-10-notifications",
    date: "2026-09-10",
    icon: "🔔",
    title: "좋아요 · 댓글 · 같은 책 알림",
    body: "내 이야기에 좋아요나 댓글이 달리면, 내가 담은 책을 다른 사람이 담으면 알려드려요.",
  },
  {
    id: "2026-09-09-constellation",
    date: "2026-09-09",
    icon: "✨",
    title: "책으로 별자리 만들기",
    body: "읽은 책으로 북두칠성과 탄생 별자리 12개 등 18개 별자리를 그려요. 넣을 책을 직접 고르고 이미지로 저장할 수 있어요.",
    go: "constellation",
  },
  {
    id: "2026-09-07-universe",
    date: "2026-09-07",
    icon: "🌌",
    title: "우주 궤적",
    body: "같은 책을 읽은 행성끼리 이어진 우주를 둘러봐요. 전체 화면으로 열고 손가락으로 확대할 수 있어요.",
    go: "trail",
  },
  {
    id: "2026-09-07-wishlist",
    date: "2026-09-07",
    icon: "🔖",
    title: "읽고 싶은 책",
    body: "읽고 싶은 책을 읽은 책과 따로 담아 둘 수 있어요.",
    go: "wishlist",
  },
  {
    id: "2026-09-05-quotes",
    date: "2026-09-05",
    icon: "✍️",
    title: "문장 모으기",
    body: "책에서 옮긴 문장이 행성의 '문장' 탭에 모여요. 다른 사람의 문장에 좋아요도 누를 수 있어요.",
    go: "quotes",
  },
  {
    id: "2026-09-05-year-trail",
    date: "2026-09-05",
    icon: "🛸",
    title: "한 해의 독서 궤적",
    body: "읽은 순서대로 감정 좌표를 이은 선을 이미지로 내보낼 수 있어요.",
    go: "orbit",
  },
  {
    id: "2026-09-04-hang-quote",
    date: "2026-09-04",
    icon: "💬",
    title: "행성에 한 문장 걸기 · 오늘의 문장",
    body: "내 행성에 한 문장을 걸어 두면, 다른 독자가 그날 처음 들어올 때 '오늘의 문장'으로 만나요.",
    go: "profile",
  },
  {
    id: "2026-09-04-visitors",
    date: "2026-09-04",
    icon: "👣",
    title: "내 행성 방문자",
    body: "누가 내 행성에 다녀갔는지 알려드려요.",
  },
  {
    id: "2026-09-03-planet-color",
    date: "2026-09-03",
    icon: "🎨",
    title: "행성 색 고르기",
    body: "10권을 읽으면 내 행성의 색을 고를 수 있어요.",
    go: "profile",
  },
  {
    id: "2026-09-02-trending",
    date: "2026-09-02",
    icon: "📚",
    title: "많이 담은 책",
    body: "사람들이 가장 많이 담은 책을 모아 봤어요.",
    go: "trending",
  },
];

export const LATEST_RELEASE = RELEASES[0].id;
